import React, { useContext, useRef } from "react";
import propTypes from "prop-types";
import { useGSAP } from "@gsap/react";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";
import Context from "../OriginStoryProvider";
import { bgShapesParallax } from "../animations/animations";

const LargeQuoteMediaAndText = ({
	elClass,
	bgImg,
	quote,
	source,
	imgCaption,
	imgSrc,
	imgAlt,
	imgShape,
	textComponent,
}) => {
	const {
		data: { content },
	} = useContext(Context);

	const headlineQuoteContainer = useRef(null);
	const headlineQuoteText = useRef(null);
	const pinnedImg = useRef(null);

	useGSAP(
		() => {
			const split = new SplitText(headlineQuoteText.current, {
				type: "chars, words",
				wordsClass: "word",
			});

			const tl = gsap
				.timeline()
				.to(`.${elClass}__large-quote__quote`, {
					"--lquo-opacity": 1,
				})
				.from(split.chars, {
					opacity: 0,
					rotate: (i) => -i * 0.1,
					y: (i) => -i * 0.1,
					skewY: -5,
					stagger: 0.2,
				})
				.from(`.${elClass}__large-quote__citation`, {
					opacity: 0,
				})
				.from(`.${elClass}__media-text`, {
					opacity: 0,
					y: 50,
				});

			ScrollTrigger.create({
				trigger: headlineQuoteContainer.current,
				start: "top top",
				pin: headlineQuoteContainer.current,
				scrub: 2,
				animation: tl,
			});

			bgImg && bgShapesParallax(pinnedImg.current, pinnedImg.current);

		},
		{ scope: headlineQuoteContainer.current, dependencies: [content.chapters] }
	);

	return (
		<div className={elClass} ref={headlineQuoteContainer}>
			{bgImg && (
				<img
					className={`${elClass}__bg-img`}
					src={bgImg}
					ref={pinnedImg}
					alt=""
					loading="lazy"
				/>
			)}
			<div className="main-grid">
				<div className="main-grid__margin"></div>
				<div className="main-grid__body">
					<div className={`${elClass}__large-quote`}>
						<p
							className={`${elClass}__large-quote__quote headline-quote`}
							ref={headlineQuoteText}
						>
							{quote}&rdquo;
						</p>
						<cite
							className={`${elClass}__large-quote__citation quote-attribute`}
							dangerouslySetInnerHTML={{
								__html: source,
							}}
						></cite>
					</div>
					<div className={`${elClass}__media-text`}>
						{/* Media and text - text, can be Deep Dive component or other text component */}
						{textComponent}

						{/* Media and text - image */}
						<figure>
							<img src={imgSrc} alt={imgAlt} />
							<figcaption className="img-caption" dangerouslySetInnerHTML={{__html : imgCaption}}/>
							{imgShape && (
								<img
									className="media-text-bg-shape bg-shape"
									src={imgShape}
									alt=""
								/>
							)}
						</figure>
					</div>
				</div>
				<div className="main-grid__margin"></div>
			</div>
		</div>
	);
};

export default LargeQuoteMediaAndText;

LargeQuoteMediaAndText.propTypes = {
	quote: propTypes.string.isRequired,
	source: propTypes.string.isRequired,
	elClass: propTypes.string.isRequired,
	bgImg: propTypes.string,
	textComponent: propTypes.element.isRequired,
	imgSrc: propTypes.string,
	imgCaption: propTypes.string,
	imgAlt: propTypes.string,
	imgShape: propTypes.string,
};
